import { createContext, useContext } from 'react';

export type PreviewLocale = 'en' | 'nl';

/**
 * Context for controlling which locale is used when rendering field titles.
 * Defaults to 'nl' (consistent with existing hardcoded behavior).
 */
const PreviewLocaleCtx = createContext<PreviewLocale>('nl');

export const PreviewLocaleProvider = PreviewLocaleCtx.Provider;

export function usePreviewLocale(): PreviewLocale {
  return useContext(PreviewLocaleCtx);
}

/**
 * Resolve a localized string pair to the preferred locale, falling back to the
 * other locale, then empty string.
 */
export function resolveLocalized(
  nl: string | undefined,
  en: string | undefined,
  locale: PreviewLocale,
): string {
  return locale === 'nl' ? nl || en || '' : en || nl || '';
}
